import React from 'react'
import PropTypes from 'prop-types'

// 自作ユーティリティ・ツール
import makeInfoTable from '../makeInfoTable'
import * as def from '../define'

/**
 * 登録完了
 */
export default class EntryComplete extends React.Component {
  constructor(props) {
    super(props)

    this.handleBtnPrintClick = this.handleBtnPrintClick.bind(this)
    this.handleBtnCloseClick = this.handleBtnCloseClick.bind(this)
  }

  // 印刷ボタン
  handleBtnPrintClick() {
    window.print()
  }

  // 閉じるボタン
  handleBtnCloseClick() {
    // window.close()
    window.open('about:blank', '_self').close()
  }

  render() {
    const boldStyle = { fontSize: 'large', fontWeight: 'bold' }
    return (
      <div className='appContent'>
        <h1>登録内容の確認</h1>
        <div style={{ lineHeight: '2em', width: '90%', marginLeft: 'auto', marginRight: 'auto' }}>
          <div style={{ textAlign: 'left' }}>
            {
              this.props.info.mode === def.MODE.CREATE_TENANT
                ? '以下の内容で登録完了しました。'
                : '以下の契約への結び付けが完了しました。'
            }
            <br />
            <span style={boldStyle}>画面に表示されている内容を印刷等で保存し、厳重に保管してください。</span><br />
            <span style={boldStyle}>また、登録されたメールアドレスに登録完了通知メールを送信しました。</span>
          </div>
          {makeInfoTable(this.props.info)}
          <button type='button' id='btnPrint' style={{ margin: '0 40px' }} onClick={this.handleBtnPrintClick}>印　刷</button>
          <button type='button' id='btnClose' style={{ margin: '0 40px' }} onClick={this.handleBtnCloseClick}>閉じる</button>
        </div>
      </div>
    )
  }
}

EntryComplete.propTypes = {
  info: PropTypes.object.isRequired,
  callbacks: PropTypes.object.isRequired
}



// WEBPACK FOOTER //
// ./src/pages/entryComplete.js